<template lang='pug'>
  .member-details-body.member-details-points-expiry
    .welcome(v-text='$t("account.rewardsBoutique.memberHeader.welcome", { name })')
    .points-content
      .content.point-balance
        .points(v-text='points')
        .points-type(v-text='$t("pointExpiry.pointBalance")')
        .due-date(v-text='$t("pointExpiry.asOfToday")')
      .content.point-expiring
        .points(v-text='pointsExpiring')
        .points-type(v-text='$t("pointExpiry.pointExpiring")')
        .due-date(v-text='pointExpiringDueDateText')
    .hyperlink-content
      a.rewards-link(
        v-if='isFullSizeEnabled'
        v-t='"account.rewardsBoutique.memberHeader.viewRedeemedRewards"'
        :href='"/account/get-it-again?tab=rewards"'
        @click='trackClick()')
      a.points-link(:href='"/account/point_logs"' v-t='"pointExpiry.pointsSummary"')
</template>

<script>
import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  name: 'MemberDetails',

  props: {
    member: {
      type: Object,
      required: true
    }
  },

  computed: {
    isFullSizeEnabled () {
      return vueSupport?.featureFlags?.enableFullSize
    },

    isMobile: () => vueSupport.isMobile,

    name () {
      return this.member.attributes['full-name']
    },

    points () {
      return this.member.attributes['points-formatted']
    },

    pointsExpiring () {
      return this.member.attributes['soonest-expiring-points']
    },

    pointExpiringDueDateText () {
      return this.$t('pointExpiry.onDate', { date: this.member.attributes['soonest-expiry-date'] })
    }
  },

  methods: {
    trackClick () {
      pushDataLayerEvent('view_redeemed_rewards_click', { params: { origin: 'rewards_boutique' } })
    }
  }
}
</script>

<style lang='scss' scoped>
  .welcome {
    text-transform: uppercase;
    line-height: normal;
  }

  .points-link, .rewards-link  {
    font-size: 12px;
    text-decoration: underline;
    letter-spacing: .3px;
    width: 80%;
  }

  .member-details-points-expiry {
    @include font-weight-medium;
    background-color: $white;
    width: 314px;
    height: 183px;
    text-align: center;
    margin: 8px;

    @include media-breakpoint-down(md) {
      width: 280px;
      margin: 2px;
      height: auto;
    }

    @include media-breakpoint-down(sm) {
      margin: auto;
    }

    > .welcome {
      font-size: 14px;
      line-height: 21px;
      @include font-weight-bold;
      margin-top: 16px;
    }

    > .points-link {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
    }

    > .points-content {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      height: 77px;
      flex-flow: row;
      min-width: 238px;
      margin: 16px;

      @include media-breakpoint-down(sm) {
        height: auto;
      }

      > .content {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        text-transform: capitalize;
        letter-spacing: 1px;
        @include font-sephora-sans;
        font-style: normal;
        font-size: 13px;
        line-height: 21px;
        height: 77px;
        width: 120px;
        margin-bottom: 10px;
      }

      > .point-balance, .point-expiring {
        > .points {
          @include font-weight-bold;
          font-size: 27px;
          line-height: 35px;
        }

        > .points-type {
          @include font-weight-bold;
          width: inherit;
        }
      }

      > .point-balance {
        border-color: $grey-light-e5;
        border-right: 1px solid $grey-light-e5;

        @include media-breakpoint-down(sm) {
          border-style: none solid none none;
        }
      }
    }

    >.hyperlink-content{
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex-flow: row;
      min-width: 238px;
    }
  }
</style>
